import React, { useState } from 'react'
import nkarr from '../images/nkarr.jpeg'
import { BrowserRouter, Link } from 'react-router-dom'

const Nav = () => {
   const[open,setopen] = useState(false)
  return (

  <nav> 
     <div className="container">
    <div className='nav-top'>
     
           <ul className='n'>
           <li className='x'><a href="tel:+7-964-514-46-40 ">+7-964-514-46-40 </a></li>
           <li className='x'><a href="tel:+7-964-514-46-40 ">+7-925-867-91-52 </a></li>
            <li>makich.avetisyan88@mail.ru</li>
            <li>Московская область</li>
           <li className='w'> <a href="https://www.instagram.com/mak.stroy.1?igsh=MTBsbmJmM2tzbXF5OA%3D%3D&utm_source=qr"  className='a'><i class="bi bi-instagram"></i></a></li>
           
        </ul>
       </div>
     
    </div>
    <div className='nav-menu'>
      <div className="container">
       <div className='logo'>
       <img src={nkarr} alt="logo" />
      </div>
      <div className='menu'>
         <ul>
        <li>
            <Link to={'/'}>Главный</Link>
        </li>
       <li>
        <Link to={'/about'}> Услуги</Link>
       </li>
       <li>
        <Link to={'/contact'}>Контакты</Link>
       </li>
       </ul>
      </div>
       <div className='mobael-menu'>
        <i class="bi bi-list-ul" onClick={() => setopen(!open)}></i>
      <ul className={open == true ? 'open-menu' : ''}>
        <li>
            <Link to={'/'}>Главный</Link>
        </li>
       <li>
        <Link to={'/about'}> Услуги</Link>
       </li>
       <li>
        <Link to={'/contact'}>Контакты</Link>
       </li>
       <span className='closbtn' onClick={() => setopen(!open)}>x</span>
       </ul>
       </div>
      </div>
     
    </div>
  </nav>
  )
}

export default Nav
